function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useTheme } from "@emotion/react";
import React from "react";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { Variant } from "~/components/newsletter/newsletter-widget/enums";
import { CheckEmailMessage, Container, Footer, IconContainer, SeeMoreLink, StyledFollowUsOnFacebook, StyledIconTickCircle, Title } from "./styles";

// TODO: missing acquisition part here

export const SignUpSuccessMessage = ({
  ...props
}) => {
  const {
    signUpSuccess
  } = useTheme();
  const {
    variant
  } = useNewsletterContext();
  const computedEmailMessage = variant === Variant.AcquisitionNewsletterPopup ? "Please check the email for further details." : "Please check your email to confirm your subscription.";
  const computedTitle = variant === Variant.AcquisitionNewsletterPopup ? "Thank you for your registration." : "Thanks for signing up to our newsletter!";
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "sign-up-success-message"
  }), /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(StyledIconTickCircle, {
    height: 25,
    width: 25
  })), /*#__PURE__*/React.createElement(Title, null, computedTitle), /*#__PURE__*/React.createElement(Footer, null, (signUpSuccess === null || signUpSuccess === void 0 ? void 0 : signUpSuccess.hasCheckEmail) && /*#__PURE__*/React.createElement(CheckEmailMessage, null, computedEmailMessage), (signUpSuccess === null || signUpSuccess === void 0 ? void 0 : signUpSuccess.hasSeeMoreLinks) && /*#__PURE__*/React.createElement(SeeMoreLink, null, "See more newsletters"), /*#__PURE__*/React.createElement(StyledFollowUsOnFacebook, null)));
};
SignUpSuccessMessage.displayName = "SignUpSuccessMessage";